module.exports = __webpack_public_path__ + "static/media/signage-indoor-img1.d7fad661.jpg";